export const RouterEnum = {
  Signin: {
    name: "Signin",
    path: "/signin",
    SetIdAndPw: {
      name: "signin-set-id-and-pw",
      path: "/set-id-and-pw",
    },
    FindId: {
      name: "signin-find-id",
      path: "/find-id",
    },
    FindIdDone: {
      name: "signin-find-id-done",
      path: "/find-id-done",
    },
    ResetPwdAuth: {
      name: "signin-reset-pwd-auth",
      path: "/reset-pwd-auth",
    },
    ResetPwd: {
      name: "signin-reset-pwd",
      path: "/reset-pwd",
    },
    ResetPwdDone: {
      name: "signin-reset-pwd-done",
      path: "/reset-pwd-done",
    },
  },
  Signup: {
    name: "Signup",
    path: "/signup",
    EnterId: {
      name: "signup-enter-id",
      path: "enter-id",
    },
    EnterIdDone: {
      name: "signup-enter-id-done",
      path: "enter-id-done",
    },
    SetIdAndPw: {
      name: "signup-set-id-and-pw",
      path: "set-id-and-pw",
    },
    Done: {
      name: "signup-done",
      path: "done",
    },
    Complete: {
      name: "signup-complete",
      path: "complete",
    },
  },

  Dashboard: {
    name: "Dashboard",
    path: "/dashboard",
  },
  Dashboard2: {
    name: "Dashboard2",
    path: "/dashboard2",
  },
  BrandSetting: {
    name: "BrandSetting",
    path: "/brand-setting",
  },

  // 인증서 발행/설정 페이지
  Zh: {
    name: "Zh",
    path: "zh",
  },
  Ja: {
    name: "Ja",
    path: "ja",
  },
  Dent: {
    name: "Dent",
    path: "/dent",
  },
  DentIssueCertificate: {
    name: "DentIssueCertificate",
    path: "certificate-issue",
  },
  DentEditCertificateContentsList: {
    name: "DentEditCertificateContentsList",
    path: "list",
  },
  DentEditCertificateContents: {
    name: "DentEditCertificateContents",
    path: "implant/edit-contents",
  },
  DentBraceEditCertificateContents: {
    name: "DentBraceEditCertificateContents",
    path: "brace/edit-contents",
  },
  DentAbutmentEditCertificateContents: {
    name: "DentAbutmentEditCertificateContents",
    path: "abutment/edit-contents",
  },
  DentZirconiaEditCertificateContents: {
    name: "DentZirconiaEditCertificateContents",
    path: "zirconia/edit-contents",
  },
  Oph: {
    name: "Oph",
    path: "/oph",
  },
  OphIssueCertificate: {
    name: "OphIssueCertificate",
    path: "certificate-issue",
  },
  OphBulkIssue: {
    name: "OphBulkIssue",
    path: "bulk-issue",
  },
  OphEditCertificateContentsList: {
    name: "OphEditCertificateContentsList",
    path: "lasik/edit-contents-list",
  },
  OphEditCertificateContents: {
    name: "OphEditCertificateContents",
    path: "lasik/edit-contents",
  },
  Ps: {
    name: "Ps",
    path: "/ps",
  },
  PsIssueCertificate: {
    name: "PsIssueCertificate",
    path: "certificate-issue",
  },
  PsEditCertificateContents: {
    name: "PsEditCertificateContents",
    path: "edit-contents",
  },
  PsCertificateSettingEntry: {
    name: "PsCertificateSettingEntry",
    path: "/ps/setting-entry",
  },
  DermCertificateSettingEntry: {
    name: "DermCertificateSettingEntry",
    path: "/derm/setting-entry",
  },
  Derm: {
    name: "Derm",
    path: "/derm",
  },
  DermIssueCertificate: {
    name: "DermIssueCertificate",
    path: "certificate-issue",
  },
  DermEditCertificateContents: {
    name: "DermEditCertificateContents",
    path: "edit-contents",
  },

  Im: {
    name: "Im",
    path: "/internal",
  },
  ImIssueCertificate: {
    name: "ImIssueCertificate",
    path: "certificate-issue",
  },
  ImEditCertificateContents: {
    name: "ImEditCertificateContents",
    path: "edit-contents",
  },

  Custom: {
    name: "Custom",
    path: "/custom",
  },

  CustomEditCertificateContents: {
    name: "CustomEditCertificateContents",
    path: "edit-contents",
  },
  Os: {
    name: "Os",
    path: "/os",
  },

  OsIssueCertificate: {
    name: "OsIssueCertificate",
    path: "certificate-issue",
  },

  OsEditCertificateContents: {
    name: "OsEditCertificateContents",
    path: "edit-contents",
  },

  Common: {
    name: "Common",
    path: "/common",
  },
  CommonIssueCertificate: {
    name: "CommonIssueCertificate",
    path: "certificate-issue",
  },
  CommonEditCertificateContents: {
    name: "CommonEditCertificateContents",
    path: "edit-contents",
  },

  Vet: {
    name: "Vet",
    path: "/vet",
  },
  VetIssueCertificate: {
    name: "VetIssueCertificate",
    path: "certificate-issue",
  },
  VetEditCertificateContents: {
    name: "VetEditCertificateContents",
    path: "edit-contents",
  },

  Order: {
    Container: {
      name: "order-container",
      path: "/order-container",
    },
  },

  ContractManagement: {
    path: "/contract",
    name: "Contract",
    ContractList: {
      path: "list",
      name: "ContractList",
    },
  },
  CertificateList: {
    name: "CertificateList",
    path: "/certificate-list",
  },
  CustomerList: {
    name: "CustomerList",
    path: "/customer-list",
  },
  CustomerDetails: {
    name: "CustomerDetails",
    path: "/customer-details",
  },
  HospitalInfo: {
    name: "HospitalInfo",
    path: "/info",
  },
  InfoPassword: {
    name: "InfoPassword",
    path: "/info-verify",
  },
  InfoEdit: {
    name: "InfoEdit",
    path: "/info-edit",
  },
  Store: {
    name: "Store",
    path: "/store",
  },
  Subscription: {
    name: "Subscription",
    path: "/subscription",
  },

  Notices: {
    name: "Notices",
    path: "/notices",
  },
  NoticeList: {
    name: "NoticeList",
    path: "list",
  },
  NoticeRead: {
    name: "NoticeRead",
    path: "", //
  },

  MobilePages: {
    name: "MobilePages",
    path: "/mobile",
  },
  MobileNoticeHospital: {
    name: "MobileNoticeHospital",
    path: "hospital-notice/list",
  },
  MobileNoticeCustomer: {
    name: "MobileNoticeCustomer",
    path: "customer-notice/list",
  },

  // 지원 접속 진입·끝(계약 SUPPORT 9)·앱 사이 이동 받기(K-17) — 로그인 검사 밖
  SupportEnter: {
    name: "SupportEnter",
    path: "/support/enter",
  },
  SupportEnded: {
    name: "SupportEnded",
    path: "/support/ended",
  },
  HandoffEnter: {
    name: "HandoffEnter",
    path: "/enter",
  },

  // 토큰이 필요한 모바일 페이지들
  MobilePagesWithToken: {
    name: "MobilePagesWithToken",
    path: "/m",
  },
  MobileCertificateList: {
    name: "MobileCertificateList",
    path: "certificate-list",
  },

  // 병원예약 관련 페이지
  ReservationList: {
    name: "ReservationList",
    path: "/reservation-list",
  },
  ReviewManagement: {
    name: "ReviewManagement",
    path: "/review",
  },
  BrowserNotification: {
    name: "BrowserNotification",
    path: "/browser-notification",
  },

  KakaoTalk: {
    name: "KakaoTalk",
    path: "/kakaotalk",
  },
  GoToApp: {
    name: "GoToApp",
    path: "/download-app",
  },

  ElectronicSign: {
    path: "/electronic-sign",
    name: "ElectronicSign",
    LaborContract: {
      path: "/electronic-sign/labor",
      name: "LaborContract",
    },
    LaborContractCreate: {
      path: "/electronic-sign/labor/create",
      name: "LaborContractCreate",
    },
    ConsentContract: {
      path: "/electronic-sign/consent",
      name: "ConsentContract",
    },
    ConsentContractTemplate: {
      path: "/electronic-sign/consent/template",
      name: "ConsentContractTemplate",
    },
    ConsentContractCreate: {
      path: "/electronic-sign/consent/create",
      name: "ConsentContractCreate",
    },
  },

  Maintenance: {
    name: "Maintenance",
    path: "/maintenance",
  },

  // 알림톡 메뉴 (상위 탭)
  Alimtalk: {
    name: "Alimtalk",
    path: "/alimtalk",
    // 하위 메뉴들
    ChannelSettings: {
      name: "AlimtalkChannelSettings",
      path: "channel",
    },
    TemplateCreate: {
      name: "AlimtalkTemplateCreate",
      path: "template/create",
    },
    TemplateList: {
      name: "AlimtalkTemplateList",
      path: "template/list",
    },
    TemplateBulkCreate: {
      name: "AlimtalkTemplateBulkCreate",
      path: "template/bulk-create",
    },
    TemplateEdit: {
      name: "AlimtalkTemplateEdit",
      path: "template/edit/:channelId/:templateCode",
    },
  },

  // 기존 경로 유지 (호환성)
  AlimtalkChannelSettings: {
    name: "AlimtalkChannelSettings",
    path: "/alimtalk/channel",
  },

  // 계정 관리
  SubAccountManagement: {
    name: "SubAccountManagement",
    path: "/account-management",
    List: {
      name: "SubAccountList",
      path: "list",
    },
    Create: {
      name: "SubAccountCreate",
      path: "create",
    },
    Edit: {
      name: "SubAccountEdit",
      path: "edit/:accountId",
    },
  },
};
